/**
 * Where one agent edit stands, for the undo on its thread card (RFC 0301 S9).
 *
 * THE SAME RULES AS THE INLINE DIFF. The card and the editor both ask history,
 * through the functions `undoAgentEdit` itself uses, so an edit one of them
 * calls undoable the other does not call changed. Nothing is stored on the card:
 * an undo from the document shows on the card because history now says so.
 *
 * PURE, over the document, so the rule is testable without rendering.
 */

import {
  locateAgentEdit,
  projectAgentEdits,
  readDocumentContent,
} from '@mod/core/model'

export type EditStatus =
  /** In the document as the agent left it: undo would take it back. */
  | 'live'
  /** An undo naming this change exists, from either place. */
  | 'undone'
  /** Somebody has since typed inside it, so undo would revert their words. */
  | 'changed'
  /** Not in this copy's history yet, or not an agent edit at all. */
  | 'unknown'

export function editStatus(doc: unknown, hash: string): EditStatus {
  const edit = projectAgentEdits(doc).find((e) => e.hash === hash)
  if (!edit) return 'unknown'
  if (edit.reverted) return 'undone'
  return locateAgentEdit(readDocumentContent(doc), edit) ? 'live' : 'changed'
}
